// extracted by mini-css-extract-plugin
export default {"sub_box":"index_sub_box_8GPoX","sub_nav":"index_sub_nav_VMw3R clearfix"};